import { DraftConfiguration, PrintArea, PrintType, Size } from '@/types';
import { Restriction } from '@/utils/embroideryRestrictions';
import { isPixelDraftConfiguration } from '@/model/configuration/isPixelDraftConfiguration';
import { getHasNoSoftBoundary } from '@/model/printArea/getHasSoftBoundary';
import { getIsDieCutStickerPrintType } from '@/model/printType/getIsDieCutStickerPrintType';
import { rotatedSize } from './rotatedSize';

export const getMaxScale = (
  size: Size,
  currentRotation: number,
  { boundary }: PrintArea,
  printType: PrintType,
  isPixelConfiguration?: boolean,
  ignoreSoftBoundary?: boolean,
  restriction?: Restriction
) => {
  let { width: maxWidth, height: maxHeight } = printType.size;
  if (ignoreSoftBoundary || getHasNoSoftBoundary(boundary)) {
    const { width: printAreaWidth, height: printAreaHeight } = boundary.size;
    maxWidth = Math.min(printAreaWidth, maxWidth);
    maxHeight = Math.min(printAreaHeight, maxHeight);
  }

  let restrictionApplies = false;
  if (restriction) {
    restrictionApplies = true;
    maxWidth = Math.min(restriction[0], maxWidth);
    maxHeight = Math.min(restriction[1], maxHeight);
  }

  if (!getIsDieCutStickerPrintType(printType) && !restrictionApplies) {
    // do not allow scaling to max size to prevent API validation errors
    //  except for stickers which only support designs
    maxWidth -= 1;
    maxHeight -= 1;
  }

  const { width: configurationWidth, height: configurationHeight } =
    currentRotation === 0 ? size : rotatedSize(currentRotation, size);
  let maxScale = Math.min(maxWidth / configurationWidth, maxHeight / configurationHeight);

  if (isPixelConfiguration && maxScale > 1) {
    maxScale = 1;
  }

  return maxScale;
};

export const getMaxScaleForConfiguration = (
  configuration: DraftConfiguration,
  restriction?: Restriction
) =>
  getMaxScale(
    configuration.size,
    configuration.rotation,
    configuration.printArea,
    configuration.printType,
    isPixelDraftConfiguration(configuration),
    true,
    restriction
  );
